import React, { useEffect } from 'react';
import HelpLayout from '../../../components/help/HelpLayout';

const StudentLifecycleHelp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumbs = [
    { name: 'Admin Guide', href: '/help/admin/dashboard' },
    { name: 'Student Lifecycle' }
  ];

  return (
    <HelpLayout title="Student Lifecycle Management" breadcrumbs={breadcrumbs}>
      <div className="help-content">
        <div className="card">
          <div className="card-body">
            <h2 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: 'var(--primary-black)',
              marginBottom: '16px'
            }}>
              Student Lifecycle Management
            </h2>
            <p style={{
              fontSize: '16px',
              color: 'var(--text-gray)',
              lineHeight: 1.6
            }}>
              Manage the complete student journey from application review to course completion and certification.
            </p>

            {/* Student Lifecycle Overview */}
            <div style={{ marginTop: '32px' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: 'var(--primary-black)',
                marginBottom: '16px'
              }}>
                🔄 Complete Student Lifecycle
              </h3>

              <div style={{ marginBottom: '24px' }}>
                <p style={{ color: 'var(--text-gray)', lineHeight: 1.6, marginBottom: '16px' }}>
                  The student lifecycle in GMSP3 Career Guidance follows a structured progression through multiple stages,
                  each requiring specific administrative actions and oversight.
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {/* Stage 1 */}
                  <div style={{
                    padding: '20px',
                    backgroundColor: '#e0f2fe',
                    borderRadius: '8px',
                    borderLeft: '4px solid #0284c7'
                  }}>
                    <h4 style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#0284c7',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <span style={{
                        backgroundColor: '#0284c7',
                        color: 'white',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 'bold'
                      }}>1</span>
                      Application Submission
                    </h4>
                    <p style={{ color: '#0284c7', margin: 0, lineHeight: 1.6 }}>
                      Student submits online application with motivation letter and acknowledges requirements.
                      System automatically validates profile completion and course availability.
                    </p>
                  </div>

                  {/* Stage 2 */}
                  <div style={{
                    padding: '20px',
                    backgroundColor: '#fef3c7',
                    borderRadius: '8px',
                    borderLeft: '4px solid #f59e0b'
                  }}>
                    <h4 style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#d97706',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <span style={{
                        backgroundColor: '#f59e0b',
                        color: 'white',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 'bold'
                      }}>2</span>
                      Application Review
                    </h4>
                    <p style={{ color: '#d97706', margin: 0, lineHeight: 1.6 }}>
                      GCRA staff review application against entry requirements, qualifications, and course capacity.
                      Priority scoring may be applied based on demographics and need.
                    </p>
                  </div>

                  {/* Stage 3 */}
                  <div style={{
                    padding: '20px',
                    backgroundColor: '#dcfce7',
                    borderRadius: '8px',
                    borderLeft: '4px solid #16a34a'
                  }}>
                    <h4 style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#16a34a',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <span style={{
                        backgroundColor: '#16a34a',
                        color: 'white',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 'bold'
                      }}>3</span>
                      Acceptance Decision
                    </h4>
                    <p style={{ color: '#16a34a', margin: 0, lineHeight: 1.6 }}>
                      Application approved or declined based on review. Accepted students receive notification
                      and instructions for next steps. Declined applications include feedback.
                    </p>
                  </div>

                  {/* Stage 4 */}
                  <div style={{
                    padding: '20px',
                    backgroundColor: '#e0f2fe',
                    borderRadius: '8px',
                    borderLeft: '4px solid #0284c7'
                  }}>
                    <h4 style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#0284c7',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <span style={{
                        backgroundColor: '#0284c7',
                        color: 'white',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 'bold'
                      }}>4</span>
                      Registration Process
                    </h4>
                    <p style={{ color: '#0284c7', margin: 0, lineHeight: 1.6 }}>
                      Student completes formal registration, submits required documents, and confirms attendance.
                      Administrative verification of credentials and final enrollment confirmation.
                    </p>
                  </div>

                  {/* Stage 5 */}
                  <div style={{
                    padding: '20px',
                    backgroundColor: '#fef3c7',
                    borderRadius: '8px',
                    borderLeft: '4px solid #f59e0b'
                  }}>
                    <h4 style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#d97706',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <span style={{
                        backgroundColor: '#f59e0b',
                        color: 'white',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 'bold'
                      }}>5</span>
                      Training Delivery
                    </h4>
                    <p style={{ color: '#d97706', margin: 0, lineHeight: 1.6 }}>
                      Student participates in training program. Progress monitoring, attendance tracking,
                      and performance assessment throughout the training period.
                    </p>
                  </div>

                  {/* Stage 6 */}
                  <div style={{
                    padding: '20px',
                    backgroundColor: '#dcfce7',
                    borderRadius: '8px',
                    borderLeft: '4px solid #16a34a'
                  }}>
                    <h4 style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#16a34a',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <span style={{
                        backgroundColor: '#16a34a',
                        color: 'white',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 'bold'
                      }}>6</span>
                      Completion & Certification
                    </h4>
                    <p style={{ color: '#16a34a', margin: 0, lineHeight: 1.6 }}>
                      Successful completion of training requirements. Certificate issuance, final assessments,
                      and transition to employment or further education pathways.
                    </p>
                  </div>
                </div>
              </div>
            {/* Administrative Actions */}
            <div style={{ marginTop: '32px' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: 'var(--primary-black)',
                marginBottom: '16px'
              }}>
                🛠️ Key Administrative Actions
              </h3>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Application Review Process
                </h4>
                <p style={{ color: 'var(--text-gray)', lineHeight: 1.6, marginBottom: '12px' }}>
                  Systematic review of student applications through the Django Admin interface:
                </p>
                <ul style={{
                  color: 'var(--text-gray)',
                  lineHeight: 1.6,
                  paddingLeft: '20px',
                  marginBottom: '16px'
                }}>
                  <li><strong>Access:</strong> Navigate to Registrations → Registrations in Django Admin</li>
                  <li><strong>Filter:</strong> Use status filters to view applications by stage</li>
                  <li><strong>Review:</strong> Check student profile, qualifications, and motivation</li>
                  <li><strong>Decision:</strong> Update status to "accepted", "declined", or request more info</li>
                  <li><strong>Notes:</strong> Add review notes for internal tracking and student feedback</li>
                </ul>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Status Management
                </h4>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                  gap: '16px',
                  marginBottom: '16px'
                }}>
                  <div style={{
                    padding: '16px',
                    backgroundColor: 'var(--background-gray)',
                    borderRadius: '6px'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: 'var(--primary-black)',
                      marginBottom: '8px'
                    }}>
                      📝 Applied → Under Review
                    </h5>
                    <p style={{ fontSize: '14px', color: 'var(--text-gray)', margin: 0 }}>
                      Automatic transition when application is submitted. Begin review process.
                    </p>
                  </div>
                  <div style={{
                    padding: '16px',
                    backgroundColor: 'var(--background-gray)',
                    borderRadius: '6px'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: 'var(--primary-black)',
                      marginBottom: '8px'
                    }}>
                      ✅ Under Review → Accepted
                    </h5>
                    <p style={{ fontSize: '14px', color: 'var(--text-gray)', margin: 0 }}>
                      Manual approval after successful review. Student notified automatically.
                    </p>
                  </div>
                  <div style={{
                    padding: '16px',
                    backgroundColor: 'var(--background-gray)',
                    borderRadius: '6px'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: 'var(--primary-black)',
                      marginBottom: '8px'
                    }}>
                      📋 Accepted → To Register
                    </h5>
                    <p style={{ fontSize: '14px', color: 'var(--text-gray)', margin: 0 }}>
                      Student confirms acceptance and begins registration process.
                    </p>
                  </div>
                  <div style={{
                    padding: '16px',
                    backgroundColor: 'var(--background-gray)',
                    borderRadius: '6px'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: 'var(--primary-black)',
                      marginBottom: '8px'
                    }}>
                      🎓 To Register → Registered
                    </h5>
                    <p style={{ fontSize: '14px', color: 'var(--text-gray)', margin: 0 }}>
                      Complete registration with document verification and enrollment.
                    </p>
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Bulk Operations
                </h4>
                <p style={{ color: 'var(--text-gray)', lineHeight: 1.6, marginBottom: '12px' }}>
                  Django Admin provides powerful bulk operations for efficient student management:
                </p>
                <ul style={{
                  color: 'var(--text-gray)',
                  lineHeight: 1.6,
                  paddingLeft: '20px',
                  marginBottom: '16px'
                }}>
                  <li><strong>Bulk Status Updates:</strong> Change multiple applications simultaneously</li>
                  <li><strong>Batch Notifications:</strong> Send announcements to specific student groups</li>
                  <li><strong>Export Functions:</strong> Generate reports and student lists</li>
                  <li><strong>Filter Operations:</strong> Target specific cohorts or demographics</li>
                </ul>
              </div>
            </div>

            {/* Monitoring and Reporting */}
            <div style={{ marginTop: '32px' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: 'var(--primary-black)',
                marginBottom: '16px'
              }}>
                📊 Monitoring and Reporting
              </h3>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Key Performance Indicators
                </h4>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                  gap: '16px',
                  marginBottom: '16px'
                }}>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#dcfce7',
                    borderRadius: '6px',
                    textAlign: 'center'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#16a34a',
                      marginBottom: '8px'
                    }}>
                      Application Volume
                    </h5>
                    <p style={{ fontSize: '14px', color: '#16a34a', margin: 0 }}>
                      Track applications per course and period
                    </p>
                  </div>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#fef3c7',
                    borderRadius: '6px',
                    textAlign: 'center'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#d97706',
                      marginBottom: '8px'
                    }}>
                      Acceptance Rates
                    </h5>
                    <p style={{ fontSize: '14px', color: '#d97706', margin: 0 }}>
                      Monitor approval percentages by course
                    </p>
                  </div>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#e0f2fe',
                    borderRadius: '6px',
                    textAlign: 'center'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#0284c7',
                      marginBottom: '8px'
                    }}>
                      Completion Rates
                    </h5>
                    <p style={{ fontSize: '14px', color: '#0284c7', margin: 0 }}>
                      Track successful course completions
                    </p>
                  </div>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#f3f4f6',
                    borderRadius: '6px',
                    textAlign: 'center'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#6b7280',
                      marginBottom: '8px'
                    }}>
                      Dropout Analysis
                    </h5>
                    <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>
                      Identify patterns in withdrawals
                    </p>
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Reporting Tools
                </h4>
                <ul style={{
                  color: 'var(--text-gray)',
                  lineHeight: 1.6,
                  paddingLeft: '20px',
                  marginBottom: '16px'
                }}>
                  <li><strong>Django Admin Reports:</strong> Built-in filtering and export capabilities</li>
                  <li><strong>Status History Tracking:</strong> Complete audit trail of status changes</li>
                  <li><strong>Demographic Analysis:</strong> Breakdown by age, location, education level</li>
                  <li><strong>Course Performance:</strong> Enrollment vs. capacity utilization</li>
                  <li><strong>Timeline Reports:</strong> Application processing times and bottlenecks</li>
                </ul>
              </div>
            </div>

            {/* Best Practices */}
            <div style={{
              padding: '20px',
              backgroundColor: 'var(--background-gray)',
              borderRadius: '8px',
              marginTop: '32px'
            }}>
              <h3 style={{
                fontSize: '18px',
                fontWeight: 'bold',
                color: 'var(--primary-black)',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                💡 Student Lifecycle Best Practices
              </h3>
              <ul style={{
                color: 'var(--text-gray)',
                lineHeight: 1.6,
                paddingLeft: '20px',
                margin: 0
              }}>
                <li><strong>Timely reviews:</strong> Process applications within 5-10 business days</li>
                <li><strong>Clear communication:</strong> Provide detailed feedback for all decisions</li>
                <li><strong>Consistent criteria:</strong> Apply entry requirements fairly and uniformly</li>
                <li><strong>Document decisions:</strong> Maintain detailed review notes for audit purposes</li>
                <li><strong>Monitor capacity:</strong> Track enrollment against course limits continuously</li>
                <li><strong>Regular reporting:</strong> Generate weekly status reports for management</li>
                <li><strong>Student support:</strong> Provide guidance throughout the registration process</li>
                <li><strong>Data integrity:</strong> Ensure accurate status updates and record keeping</li>
                <li><strong>Compliance tracking:</strong> Monitor adherence to GCRA policies and procedures</li>
              </ul>
            </div>

            </div>
          </div>
        </div>
      </div>
    </HelpLayout>
  );
};

export default StudentLifecycleHelp;
